import { getToken, getEnvOnly } from "../../helpers/Meet";
import {
  autorizar,
  consultarCliente,
  guardarSolicitud
} from "../../helpers/colmedica_huella";
import _get from "lodash/get";

export default {
  goToView({ commit }, value) {
    commit("setState", { key: "view", value });
  },
  setService({ commit }, value) {
    commit("setState", { key: "service", value });
  },
  setExplanation({ commit }, value) {
    commit("setState", { key: "explanation", value });
  },
  selecteService({ commit }, value) {
    commit("setState", { key: "servicioSelected", value });
  },
  captchaValidation({ dispatch, commit, state }) {
    if (window.grecaptcha && window.grecaptcha.ready) {
      return new Promise((res, rej) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(getEnvOnly().VUE_APP_RECAPTCHA_CODE, {
              action: "submit_identification"
            })
            .then(token =>
              getToken(token, "g_recaptcha_v3", {
                bunitId: getEnvOnly().VUE_APP_BUNIT
              })
            )
            .then(() => res())
            .catch(err => {
              commit("setState", {
                key: "validationErrors",
                value: [...state.validationErrors, err]
              });
              dispatch("errorValidationTemporizer");
              console.error("error in recaptcha request.");
              rej(err);
            });
        });
        // throw new Error('aska');
      })
        .then(() => true)
        .catch(error => {
          console.error(error);
          dispatch("goToView", "ErrorAutenticateVal");
        });
    }
    return Promise.reject(new Error("Recaptcha is not ready"));
  },
  demoValidation({ commit, dispatch }) {
    commit("setState", { key: "charging", value: true });
    return dispatch("captchaValidation")
      .then(
        () =>
          new Promise(res => {
            setTimeout(res, 2000);
            // throw new Error("Blña");
          })
      )
      .then(() => {
        commit("setState", {
          key: "client",
          value: {
            Celular: "3002356201",
            Correo: "pperez@test.com",
            Nombres: "PEPITO",
            PrimerApellido: "PEREZ",
            Resultado: 1,
            SegundoApellido: "DEMO"
          }
        });
        dispatch("goToView", "VerificationData");
        commit("setState", { key: "charging", value: false });
      })
      .catch(err => {
        commit("setState", { key: "charging", value: false });
        console.error("Error cached in Autenticate.vue -> demoValidation", err);
        dispatch("goToView", "ErrorAutenticateVal");
      });
  },
  async authAndQueryColmedica({ commit, dispatch }, pay) {
    commit("setState", { key: "charging", value: true });
    try {
      const data = await dispatch("captchaValidation");
      dispatch(
        "log/put",
        {
          name: "Autoservice.actions. El captcha se validó bien."
        },
        { root: true }
      );
      if (data) {
        await dispatch("autorizacionColmedica", pay);
        dispatch(
          "log/put",
          {
            name:
              "Autoservice.actions. La verificación del usuario fue correcta."
          },
          { root: true }
        );
        dispatch("consultaClienteColmedica", pay);
        dispatch("goToView", "VerificationData");
        commit("setState", { key: "charging", value: false });
      }
    } catch (error) {
      dispatch(
        "log/put",
        {
          name: "Autoservice.actions. Falló la autenticación del usuario.",
          checked: false,
          message: error
        },
        { root: true }
      );
      console.error("ERROR", error);
      return;
    }
  },
  autorizacionColmedica({ commit, dispatch, state }, pay) {
    return autorizar({
      TipoIdentificacion: pay.ti,
      NumeroIdentificacion: pay.nu
    }).catch(err => {
      commit("setState", {
        key: "validationErrors",
        value: [...state.validationErrors, err]
      });
      dispatch("errorValidationTemporizer");
      console.error("error in autorizacion colmedica.");
      commit("setState", { key: "charging", value: false });
      console.error(
        "Error cached in Autenticate.vue -> authAndQueryColmedica",
        err
      );
      dispatch("goToView", "ErrorAutenticate");
      throw err;
    });
  },
  consultaClienteColmedica({ commit, dispatch, state }, pay) {
    return consultarCliente({
      TipoIdentificacion: pay.ti,
      NumeroIdentificacion: pay.nu
    })
      .then(client => commit("setState", { key: "client", value: client }))
      .catch(err => {
        commit("setState", {
          key: "validationErrors",
          value: [...state.validationErrors, err]
        });
        dispatch("errorValidationTemporizer");
        console.error("error in autorizacion colmedica.");
        throw err;
      });
  },
  guardarSolicitudDemo({ commit }) {
    return new Promise(res => setTimeout(res, 2000))
      .then(() => "123456789")
      .then(value => {
        commit("setState", {
          key: "colmedicaRequest",
          value
        });
        return value;
      });
  },
  guardarSolicitudColmedica({ state, commit }) {
    let toSend = {
      ParametroSolicitudCanal: {
        CanalIngreso: 6,
        DescripcionCanal: "Descripcion Canal",

        Identificacion: `${_get(state.b64final, "ti") || ""}${_get(
          state.b64final,
          "nu"
        ) || ""}`,

        NombreUsuario: `${_get(state.client, "Nombres") || ""} ${_get(
          state.client,
          "PrimerApellido"
        ) || ""} ${_get(state.client, "SegundoApellido") || ""}`.trim(),

        CorreoElectronico: _get(state.client, "Correo") || "",
        TelefonoCelular: _get(state.client, "Celular") || "",
        TipoAutorizacionId: _get(state.servicioSelected, "code")
      },
      ArchivoSolicitud: state.files.map(file => ({
        Archivo: _get(file, "info.b64"),
        NombreArchivo: _get(file, "info.name")
      }))
    };
    return guardarSolicitud(toSend).then(data => {
      let value = _get(data, "RespuestaSolicitud.IdSolicitud");
      commit("setState", {
        key: "colmedicaRequest",
        value
      });
      return value;
    });
  },
  errorValidationTemporizer({ commit, state }) {
    if (state.errorValidationTemporizer !== null)
      clearTimeout(state.errorValidationTemporizer);
    if (!state.validationErrors.length) return;
    let timer = setTimeout(() => {
      commit("setState", { key: "validationErrors", value: [] });
      commit("setState", { key: "errorValidationTemporizer", value: null });
    }, 5000);
    commit("setState", { key: "errorValidationTemporizer", value: timer });
  },

  updateB64Final({ commit, state }, value) {
    let currentState = state.b64final;
    commit("setState", {
      key: "b64final",
      value: Object.assign({}, currentState, value)
    });
  },

  // functions documents
  clearDocs({ commit }) {
    commit("setState", { key: "files", value: [] });
  },
  removeFile({ state, commit }, keyIndex) {
    let currentFiles = state.files;
    currentFiles.splice(keyIndex, 1);
    commit("setState", { key: "files", value: currentFiles });
  },
  addFile({ state, commit }, file) {
    let currentFiles = state.files;
    currentFiles.push(file);
    commit("setState", { key: "files", value: currentFiles });
  },
  setHorarioOutContinue({ commit }, value) {
    commit("setState", { key: "HorarioOutContinue", value });
  }
};
